import React from 'react';

import { EditableInput } from '@/views/components/inputs';
import ChartPicker from './ChartPicker';

import { PERFORMANCE_CHART, CHART_STARTING_CAPITAL } from '@/utils/constants';
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import classNames from 'classnames';

type Props = {
  selectedChart: PERFORMANCE_CHART;
  chartTitles: Partial<Record<PERFORMANCE_CHART, string>>;
  showPerformancePicker: boolean;
  chartPickerProps: any;
  capital: number;
  formattedCapital: string;
  readOnly?: boolean;
  dark?: boolean;
  onCapitalChange: (value: string) => void;
  onBlurCapitalChange: () => void;
  toolbar?: React.ReactNode;
};

const ChartHeader: React.FC<Props> = ({
  selectedChart,
  chartTitles,
  showPerformancePicker,
  chartPickerProps,
  capital,
  formattedCapital,
  readOnly,
  dark,
  onCapitalChange,
  onBlurCapitalChange,
  toolbar,
}) => (
  <div className="chart-header">
    <div className={classNames('chart-title', { dark })}>
      <FormattedMessage id={chartTitles[selectedChart] || 'Charts.Growth.Title'} />
      {selectedChart === PERFORMANCE_CHART.GROWTH && (
        <>
          {'\u00a0'}
          <EditableInput
            readOnly={readOnly}
            compact
            type="number"
            dark={dark}
            value={capital ?? CHART_STARTING_CAPITAL}
            onBlur={onBlurCapitalChange}
            formattedValue={formatMessage('Charts.Growth.FormattedCurrency', { capital: formattedCapital })}
            onValueChange={onCapitalChange}
          />
        </>
      )}
    </div>
    <div className="header-actions chart">
      {showPerformancePicker && <ChartPicker {...chartPickerProps} />}
      {toolbar && toolbar}
    </div>
  </div>
);

export default ChartHeader;
